export abstract class Entity {
    _id?: string;
    creation?: AuditItem;
    update?: AuditItem;
    deletion?: AuditItem;
}

export interface AuditItem {
    user?: string;
    instant: Date;
}
